import { maintenanceType, maintenanceTypeFullName } from "../types/index.const";

const maintenanceTypeOptions = maintenanceType.map((el, index) => ({
  label: maintenanceTypeFullName[index],
  value: el,
}));

export default maintenanceTypeOptions;
